import {BrickSnake2000Symbol} from "./BrickSnake2000Symbol";
import {SymbolArgs} from "./BrickSnake2000Symbol"
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";
import {BrickSnake2000} from "../../BrickSnake2000";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {gsap} from "gsap";

export class FreespinsMultiplierSymbol extends BrickSnake2000Symbol {
    public multiplierValue:number;
    private multiplier:PIXI.BitmapText;
    private landAnimation:PIXI.spine.Spine;

    constructor(args:SymbolArgs) {
        args.suffix = args.symbolName == "MU"
                      ? args.symbolSize > 14
                        ? "_Gold"
                        : args.symbolSize > 4
                        ? "_Silver"
                        : "_Bronze"
                      : "";
        super(args);
        this.multiplierValue = args.symbolSize;

        const isCoin = args.symbolName == "MU";

        if (!isCoin) {
            this.landAnimation =
                new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.FS_MULTI));
            this.view.addChild(this.landAnimation);
        }

        this.multiplier = new PIXI.BitmapText(`${isCoin ? "x" : "+" }${args.symbolSize}`, {
            fontName : isCoin
                       ? BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI
                       : BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI_PINK,
            fontSize : 40,
        });
        (<PIXI.Point>this.multiplier.anchor).set(0.5, 0.5);
        this.view.addChild(this.multiplier);
        this.makeCoinFit();
    }

    private makeCoinFit():void {
        this.multiplier.scale.set(1,1);
        if (this.multiplier.width > 110) {
            const newScale = 110 / this.multiplier.width;
            this.multiplier.scale.set(newScale, newScale);
        }
    }

    private updateCoinLevel(value:number) {
        const coinSuffix = value > 14
                           ? "_Gold"
                           : value > 4
                           ? "_Silver"
                           : "_Bronze";
        this.view.removeChild(this.mainSprite);
        this.view.removeChild(this.spinSprite);

        this.spinSprite =
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath(this.symbolName, coinSuffix + "_spin"))[0])
        this.spinSprite.anchor.set(0.5,0.5);
        this.spinSprite.alpha = 0;

        this.mainSprite =
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath(this.symbolName, coinSuffix))[0]);
        this.mainSprite.anchor.set(0.5,0.5);
        this.mainSprite.alpha = 1;

        this.view.addChildAt(this.spinSprite, 0);
        this.view.addChildAt(this.mainSprite, 0);
        this.makeCoinFit();
    }

    public getLandAnimation():gsap.core.Timeline {
        return this.symbolName == "MU"
            ? super.getLandAnimation()
            : this.multiplierLandAnimation();
    }

    private multiplierLandAnimation(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.landAnimation.alpha = 1;
                this.mainSprite.alpha = 0;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.landAnimation, 0, `SE_Land`))
            .add(() => {
                this.landAnimation.alpha = 0;
                this.mainSprite.alpha = 1;
                this.moveToNormalLayer();
            })
    }

    public moveToWallet():gsap.core.Timeline {
        return gsap.timeline();
    }

    public updateValue(oldMultiplier:number, newMultiplier:number) {
        this.multiplierValue = (this.multiplierValue / oldMultiplier) * newMultiplier;
        this.multiplier.text = `x${this.multiplierValue}`;
        this.updateCoinLevel(this.multiplierValue);
    }
}